import { useCallback, useLayoutEffect, useRef } from 'react';

// Subscription/event callbacks keep their identity while reading the latest render.
// Effects must still list the inputs that should actually trigger their work.
export function useEventCallback(callback) {
  const latest = useRef(callback);
  useLayoutEffect(() => {
    latest.current = callback;
  });
  return useCallback((...args) => latest.current(...args), []);
}
